import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface CaseStudyCardProps {
  title: string;
  category: string;
  image: string;
  alt: string;
  challenge: string;
  solution: string;
  outcome: string;
  guestName: string;
  guestRole: string;
}

export default function CaseStudyCard({
  title,
  category,
  image,
  alt,
  challenge,
  solution,
  outcome,
  guestName,
  guestRole
}: CaseStudyCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden border border-border">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-accent text-white text-xs font-semibold px-3 py-1 rounded-full">
            {category}
          </span>
        </div>
      </div>

      <div className="p-6">
        <h3 className="font-display text-xl font-semibold text-text-primary mb-4">
          {title}
        </h3>

        <div className="space-y-4">
          <div>
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="ExclamationTriangleIcon" size={18} className="text-error" />
              <h4 className="font-semibold text-sm text-text-primary">Challenge</h4>
            </div>
            <p className="text-sm text-text-secondary leading-relaxed pl-7">
              {challenge}
            </p>
          </div>

          <div>
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="LightBulbIcon" size={18} className="text-accent" />
              <h4 className="font-semibold text-sm text-text-primary">Solution</h4>
            </div>
            <p className="text-sm text-text-secondary leading-relaxed pl-7">
              {solution}
            </p>
          </div>

          <div>
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="CheckCircleIcon" size={18} className="text-success" />
              <h4 className="font-semibold text-sm text-text-primary">Outcome</h4>
            </div>
            <p className="text-sm text-text-secondary leading-relaxed pl-7">
              {outcome}
            </p>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-border">
          <p className="text-sm text-text-secondary">
            <span className="font-semibold text-text-primary">{guestName}</span>
            <br />
            {guestRole}
          </p>
        </div>
      </div>
    </div>
  );
}